import { Button, Heading, Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";
import { Flex, styled } from "styled-system/jsx";
import { useFeatureFlag } from "shared/contextProviders/featureFlags";
import { FeatureFlags } from "shared/featureFlags";

const STEPS = ["1", "2", "3", "4", "5"];

export const HowToTestCard = ({
  membershipTranslationValues,
}: {
  membershipTranslationValues: Record<string, string>;
}) => {
  const { t } = useTranslation("home", {
    keyPrefix: "VIEWS.SETTINGS.VIEWS.MEMBERSHIP_TIERS.CHECKLIST.HOW_TO_TEST",
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const testDataEnabled = useFeatureFlag(FeatureFlags.OnboardingTestDataTool);

  return (
    <Flex
      flexDir="column"
      gap="150"
      p="300"
      borderWidth="1px"
      borderColor="border.light"
      borderRadius="200"
      bg="bg.wa.lightest"
    >
      <Heading size="h6">{t("TITLE", membershipTranslationValues)}</Heading>
      {testDataEnabled ? (
        <>
          <Text size="sm" color="text.mid">
            {t("INTRO", membershipTranslationValues)}
          </Text>
          <Button
            visual="accent.blue"
            mode="light"
            width="auto"
            onClick={() => {
              const next = new URLSearchParams(searchParams);
              next.set("settingsSubView", "TEST_TOOLS");
              setSearchParams(next);
            }}
          >
            {t("OPEN_TEST_TOOLS", membershipTranslationValues)}
          </Button>
        </>
      ) : (
        <>
          <Text size="sm" color="text.mid">
            {t("INTRO_STEPS", membershipTranslationValues)}
          </Text>
          <styled.ol
            display="flex"
            flexDir="column"
            gap="100"
            pl="400"
            listStyleType="decimal"
          >
            {STEPS.map(step => (
              <Text as="li" key={step} size="sm" color="text.mid">
                {t(`STEP_${step}`, membershipTranslationValues)}
              </Text>
            ))}
          </styled.ol>
        </>
      )}
    </Flex>
  );
};
